import React from 'react';

interface LoadingProps {
  size?: 'small' | 'medium' | 'large';
}

export const Loading: React.FC<LoadingProps> = ({ size = 'medium' }) => {
  const sizes = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  return (
    <div className="flex justify-center items-center">
      <div 
        className={`${sizes[size]} border-4 border-mbegu-primary/30 
        border-t-mbegu-primary rounded-full animate-spin`}
      />
    </div>
  );
};